let count = 0;
if(typeof $.cookie('juices') != 'undefined') {
  count = parseInt($.cookie('juices'));
}
$(document).ready(function () {

  function juiceDrawer(count, image1, image2, image3, image4, image5, title1, title2, title3, title4, title5) {
    $('.list_container').hide();
    var qty = 1;

    if (title1) {
      $('.list_index_1').show();
      $('.list_index_1 .basket-item-title img').attr('src', image1);
      $('.list_index_1 .basket-item-title .css-rdb6qo').text(title1);
      $('.list_index_1 .drawer_list_qty').text('x ' + qty);
    }

    if (title2) {
      $('.list_index_2').show();
      $('.list_index_2 .basket-item-title img').attr('src', image2);
      $('.list_index_2 .basket-item-title .css-rdb6qo').text(title2);
      $('.list_index_2 .drawer_list_qty').text('x ' + qty);
    }

    if (title3) {
      $('.list_index_3').show();
      $('.list_index_3 .basket-item-title img').attr('src', image3);
      $('.list_index_3 .basket-item-title .css-rdb6qo').text(title3);
      $('.list_index_3 .drawer_list_qty').text('x ' + qty);
    }

    if (title4) {
      $('.list_index_4').show();
      $('.list_index_4 .basket-item-title img').attr('src', image4);
      $('.list_index_4 .basket-item-title .css-rdb6qo').text(title4);
      $('.list_index_4 .drawer_list_qty').text('x ' + qty);
    }

    if (title5) {
      $('.list_index_5').show();
      $('.list_index_5 .basket-item-title img').attr('src', image5);
      $('.list_index_5 .basket-item-title .css-rdb6qo').text(title5);
      $('.list_index_5 .drawer_list_qty').text('x ' + qty);
    }
  }

  $(document).on('click', '.addTobox', function (e) {
    e.preventDefault();
    var $this = $(this);
    var title = $(this).parents('.innerWrapper').find('.pro_title').text();
    var image = $(this).parents('.innerWrapper').find('.productImg').data('bg');

    $('.productThumb .item').each(function () {
      $(this).find('itemAdd:not(.added)').eq(0).find('.wrapper').html('<img src="' + image + '" alt="Product" class="img-fluid">');
    });

    //     Juices Count
    var juices = $.cookie('juices');
    if (typeof juices == 'undefined') {
      count = parseInt(count) + parseInt(1);
    } else {
      count = parseInt(juices) + parseInt(1);
    }
    $.cookie("juices", count, { path: '/' });

    if (count == 0) {
      $('#product .addProduct').hide();
      $('.custom-pages .js-cluster-wrapper').hide();
    } else {
      $('#product .addProduct').show();
      $('.custom-pages .js-cluster-wrapper').show();
    }

    if (count > 5 || count == 5) {
      $('.productBox .addTobox').addClass('disabled');
      $('.productBox .addTobox').text('Basket Full');
    }

    if (count == 5) {
      openNav();
    }

    $('.counter').text(count);
    $('.custom-pages .total_selected_juice').text(count);
    $('.juice_drawer_count').text(count);

    let currentCount = 1;
    for( i = 1; i <6 ; i++ ){
      if(typeof $.cookie('juiceQ'+i) === 'undefined') {
        currentCount = i;
        break;        
      } else if($.cookie('juiceQ'+i).trim() === '') {
        currentCount = i;
        break;
      }
    }

    $('.juice_' + currentCount).find('.wrapper').html('<a href="javascript:;" class="removeItem"><span class="material-icons">cancel</span></a><img src="' + image + '" alt="Product" class="img-fluid">');

    //     Juices Title
    var jT = 'juiceT' + currentCount;
    var juice_title = $.cookie(jT);
    $.cookie(jT, title, { path: '/' });


    //     Juices Image
    var jP = 'juiceP' + currentCount;
    var juice_image = $.cookie(jP);
    $.cookie(jP, image, { path: '/' });

    $('.productBox .items[data-title="' + title + '"]').addClass('added');

    var juices = $.cookie('juices');
    var image1 = $.cookie('juiceP1');
    var image2 = $.cookie('juiceP2');
    var image3 = $.cookie('juiceP3');
    var image4 = $.cookie('juiceP4');
    var image5 = $.cookie('juiceP5');

    var title1 = $.cookie('juiceT1');
    var title2 = $.cookie('juiceT2');
    var title3 = $.cookie('juiceT3');
    var title4 = $.cookie('juiceT4');
    var title5 = $.cookie('juiceT5');
    juiceDrawer(juices, image1, image2, image3, image4, image5, title1, title2, title3, title4, title5);

    if ($this.hasClass('add_again')) {
      setTimeout(function () {
        $this.addClass('disabled');
      }, 30);
    }

    //var q = parseInt($(this).parents('.items').data('qty')) + parseInt(1);
    var q = parseInt($('div[data-title="' + title + '"]').attr('data-qty'));
    q = q + 1;
    $('div[data-title="' + title + '"]').attr('data-qty', q);

    var jQ = 'juiceQ' + currentCount;
    $.cookie(jQ, 1, { path: '/' });

  });

  var q1 = $.cookie('juiceQ1');
  var q2 = $.cookie('juiceQ2');
  var q3 = $.cookie('juiceQ3');
  var q4 = $.cookie('juiceQ4');
  var q5 = $.cookie('juiceQ5');

  var juices = $.cookie('juices');
  var image1 = $.cookie('juiceP1');
  var image2 = $.cookie('juiceP2');
  var image3 = $.cookie('juiceP3');
  var image4 = $.cookie('juiceP4');
  var image5 = $.cookie('juiceP5');

  var title1 = $.cookie('juiceT1');
  var title2 = $.cookie('juiceT2');
  var title3 = $.cookie('juiceT3');
  var title4 = $.cookie('juiceT4');
  var title5 = $.cookie('juiceT5');

  for(i = 1 ; i < 6 ; i++) {
    let tString = $.cookie('juiceT'+i);
    let currentQ = parseInt($('.productBox .items[data-title="' + tString + '"]').attr('data-qty'));
    currentQ = currentQ + 1;
    $('.productBox .items[data-title="' + tString + '"]').attr('data-qty', currentQ);
  }

  juiceDrawer(juices, image1, image2, image3, image4, image5, title1, title2, title3, title4, title5);

  if (typeof juices == 'undefined' || juices == 0) {
    $('#product .addProduct').hide();
    $('.custom-pages .js-cluster-wrapper').hide();
  }
  else {
    $('#product .addProduct').show();
    $('.custom-pages .js-cluster-wrapper').show();
  }

  if (juices >= 5) {
    $('.productBox .addTobox').addClass('disabled');
    $('.productBox .addTobox').text('Basket Full');
  }
  else {
    $('.productBox .items[data-title="' + title1 + '"]').addClass('added');
    $('.productBox .items[data-title="' + title2 + '"]').addClass('added');
    $('.productBox .items[data-title="' + title3 + '"]').addClass('added');
    $('.productBox .items[data-title="' + title4 + '"]').addClass('added');
    $('.productBox .items[data-title="' + title5 + '"]').addClass('added');
  }
  $('.counter').text(juices);
  $('.custom-pages .total_selected_juice').text(juices);
  $('.juice_drawer_count').text(juices);

  if (typeof image1 != 'undefined') {
    if (image1 != '') {
      $('.juice_1').find('.wrapper').html('<a href="javascript:;" class="removeItem"><span class="material-icons">cancel</span></a><img src="' + image1 + '" alt="Product" class="img-fluid">');
    }
    else {
      $('.juice_1').find('.wrapper').html('<span class="material-icons addIcon">add</span>');
    }
  }

  if (typeof image2 != 'undefined') {
    if (image2 != '') {
      $('.juice_2').find('.wrapper').html('<a href="javascript:;" class="removeItem"><span class="material-icons">cancel</span></a><img src="' + image2 + '" alt="Product" class="img-fluid">');
    }
    else {
      $('.juice_2').find('.wrapper').html('<span class="material-icons addIcon">add</span>');
    }
  }

  if (typeof image3 != 'undefined') {
    if (image3 != '') {
      $('.juice_3').find('.wrapper').html('<a href="javascript:;" class="removeItem"><span class="material-icons">cancel</span></a><img src="' + image3 + '" alt="Product" class="img-fluid">');
    }
    else {
      $('.juice_3').find('.wrapper').html('<span class="material-icons addIcon">add</span>');
    }
  }

  if (typeof image4 != 'undefined') {
    if (image4 != '') {
      $('.juice_4').find('.wrapper').html('<a href="javascript:;" class="removeItem"><span class="material-icons">cancel</span></a><img src="' + image4 + '" alt="Product" class="img-fluid">');
    }
    else {
      $('.juice_4').find('.wrapper').html('<span class="material-icons addIcon">add</span>');
    }
  }

  if (typeof image5 != 'undefined') {
    if (image5 != '') {
      $('.juice_5').find('.wrapper').html('<a href="javascript:;" class="removeItem"><span class="material-icons">cancel</span></a><img src="' + image5 + '" alt="Product" class="img-fluid">');
    }
    else {
      $('.juice_5').find('.wrapper').html('<span class="material-icons addIcon">add</span>');
    }
  }


  $(document).on('click', '.removeItem', function (e) {
    e.preventDefault();
    var index = $(this).parents('.item').data('index');

    var j = '.juice_' + index;
    var juices = parseInt($.cookie('juices') - (1));
    var jT = 'juiceT' + index;
    var jP = 'juiceP' + index;
    var jQ = 'juiceQ' + index;
    title = $.cookie(jT);
    var before_qty = parseInt($('div[data-title="' + title + '"]').attr('data-qty'));
    before_qty = before_qty - 1;
    if(before_qty < 0) {
      before_qty = 0;
    }
    $('div[data-title="' + title + '"]').attr('data-qty', before_qty);

    $.cookie('juices', juices, { path: '/' });
    $.cookie(jT, '', { path: '/' });
    $.cookie(jP, '', { path: '/' });
    $.cookie(jQ, '', { path: '/' });

    $('.counterBox ' + j).find('.wrapper').html('<span class="material-icons addIcon">add</span>');
    $(this).parents('.list_container').hide();

    var juice_count = $.cookie('juices');

    if (juice_count == 0) {
      $('#product .addProduct').hide();
      $('.custom-pages .js-cluster-wrapper').hide();
    }
    else {
      $('#product .addProduct').show();
      $('.custom-pages .js-cluster-wrapper').show();
    }

    if (juice_count < 5) {
      $('.productBox .addTobox').removeClass('disabled');
      $('.productBox .addTobox').html('Add to box <span class="material-icons">add</span>');
      $('.productBox .add_again.addTobox').html('Add Again <span class="material-icons">add</span>');
    }

    $('.counter').text(juice_count);
    $('.custom-pages .total_selected_juice').text(juice_count);
    $('.juice_drawer_count').text(juice_count);
    count = count - 1 ;

  });

  $('input[name="radioGroup"]').on('change', function (e) {
    e.preventDefault();
    var id = $(this).data('var-id');
    var sub_id = $(this).data('sub-id');
    var freq = $(this).data('frequency');
    var unit = $(this).data('unit');

    $('.mobile.custom-btn').attr('data-var-id', id);
    $('.mobile.custom-btn').attr('data-sub-id', sub_id);
    $('.mobile.custom-btn').attr('data-frequency', freq);
    $('.mobile.custom-btn').attr('data-unit', unit);
  });

  $(document).on('click', '.date_pick_btn', function (e) {
    e.preventDefault();
    var id = $(this).data('var-id');
    var sub_id = $(this).data('sub-id');
    var freq = $(this).data('frequency');
    var unit = $(this).data('unit');

    $('#datePicker .custom_atc_btn').attr('data-var-id', id);
    $('#datePicker .custom_atc_btn').attr('data-sub-id', sub_id);
    $('#datePicker .custom_atc_btn').attr('data-freq', freq);
    $('#datePicker .custom_atc_btn').attr('data-unit', unit);

  });

  $(document).on('click', '.custom_atc_btn', function (e) {
    e.preventDefault();
    var itemsArray = Array();
    var titleArray = Array();

    var id = $(this).data('var-id');
    var sub_id = $(this).data('sub-id');
    var freq = $(this).data('freq');
    var unit = $(this).data('unit');
    var qty = 1;

    var juice_title1 = $.cookie('juiceT1');
    var juice_title2 = $.cookie('juiceT2');
    var juice_title3 = $.cookie('juiceT3');
    var juice_title4 = $.cookie('juiceT4');
    var juice_title5 = $.cookie('juiceT5');

    if (typeof juice_title1 != 'undefined' && typeof juice_title2 != 'undefined' && typeof juice_title3 != 'undefined' && typeof juice_title4 != 'undefined' && typeof juice_title5 != 'undefined') {
      if (juice_title1 != '' && juice_title2 != '' && juice_title3 != '' && juice_title4 != '' && juice_title5 != '') {
        titleArray.push(juice_title1, juice_title2, juice_title3, juice_title4, juice_title5);
      }
      else if (juice_title1 != '' && juice_title2 != '' && juice_title3 != '' && juice_title4 != '' && juice_title5 == '') {
        titleArray.push(juice_title1, juice_title2, juice_title3, juice_title4);
      }
      else if (juice_title1 != '' && juice_title2 != '' && juice_title3 != '' && juice_title4 == '' && juice_title5 == '') {
        titleArray.push(juice_title1, juice_title2, juice_title3);
      }
      else if (juice_title1 != '' && juice_title2 != '' && juice_title3 == '' && juice_title4 == '' && juice_title5 == '') {
        titleArray.push(juice_title1, juice_title2);
      }
      else if (juice_title1 != '' && juice_title2 == '' && juice_title3 == '' && juice_title4 == '' && juice_title5 == '') {
        titleArray.push(juice_title1);
      }
      else { }
    }

    else if (typeof juice_title1 != 'undefined' && typeof juice_title2 != 'undefined' && typeof juice_title3 != 'undefined' && typeof juice_title4 != 'undefined' && typeof juice_title5 == 'undefined') {
      if (juice_title1 != '' && juice_title2 != '' && juice_title3 != '' && juice_title4 != '') {
        titleArray.push(juice_title1, juice_title2, juice_title3, juice_title4);
      }
      else if (juice_title1 != '' && juice_title2 != '' && juice_title3 != '' && juice_title4 == '') {
        titleArray.push(juice_title1, juice_title2, juice_title3);
      }
      else if (juice_title1 != '' && juice_title2 != '' && juice_title3 == '' && juice_title4 == '') {
        titleArray.push(juice_title1, juice_title2);
      }
      else if (juice_title1 != '' && juice_title2 == '' && juice_title3 == '' && juice_title4 == '') {
        titleArray.push(juice_title1);
      }
      else { }
    }

    else if (typeof juice_title1 != 'undefined' && typeof juice_title2 != 'undefined' && typeof juice_title3 != 'undefined' && typeof juice_title4 == 'undefined' && typeof juice_title5 == 'undefined') {
      if (juice_title1 != '' && juice_title2 != '' && juice_title3 != '') {
        titleArray.push(juice_title1, juice_title2, juice_title3);
      }
      else if (juice_title1 != '' && juice_title2 != '' && juice_title3 == '') {
        titleArray.push(juice_title1, juice_title2);
      }
      else if (juice_title1 != '' && juice_title2 == '' && juice_title3 == '') {
        titleArray.push(juice_title1);
      }
      else { }
    }

    else if (typeof juice_title1 != 'undefined' && typeof juice_title2 != 'undefined' && typeof juice_title3 == 'undefined' && typeof juice_title4 == 'undefined' && typeof juice_title5 == 'undefined') {
      if (juice_title1 != '' && juice_title2 != '') {
        titleArray.push(juice_title1, juice_title2);
      }
      else if (juice_title1 != '' && juice_title2 == '') {
        titleArray.push(juice_title1);
      }
      else { }
    }

    else if (typeof juice_title1 != 'undefined' && typeof juice_title2 == 'undefined' && typeof juice_title3 == 'undefined' && typeof juice_title4 == 'undefined' && typeof juice_title5 == 'undefined') {
      if (juice_title1 != '') {
        titleArray.push(juice_title1);
      }
    }

    var data = {
      "id": id,
      "quantity": qty,
      "properties": {
        'subscription_id': sub_id,
        'shipping_interval_frequency': freq,
        'shipping_interval_unit_type': unit,
        'juices': titleArray.join()
      }
    }

    itemsArray.push(data);

    $.ajax({
      type: 'POST',
      url: '/cart/add.js',
      data: { items: itemsArray },
      dataType: 'json',
      success: function (data) {
        /*construct url */
        function get_cookie(name) { return (document.cookie.match('(^|; )' + name + '=([^;]*)') || 0)[2] }
        var token = get_cookie('cart');
        var myshopify_domain = 'nutriseeduk.myshopify.com';

        try { var ga_linker = ga.getAll()[0].get('linkerParam') } catch (err) { var ga_linker = '' }

        var checkout_url = "https://checkout.rechargeapps.com/r/checkout?myshopify_domain=" + myshopify_domain + "&cart_token=" + token + "&" + ga_linker;
        window.location.href = checkout_url;
      },
      error: function (data) {
        alert(data.responseJSON.description);
      }
    });

  });

  //on screen fix button js start
  function isOnScreen(elem) {
    // if the element doesn't exist, abort
    if (elem.length == 0) {
      return;
    }
    var $window = jQuery(window)
    var viewport_top = $window.scrollTop()
    var viewport_height = $window.height()
    var viewport_bottom = viewport_top + viewport_height
    var $elem = jQuery(elem)
    var top = $elem.offset().top
    var height = $elem.height()
    var bottom = top + height

    return (top >= viewport_top && top < viewport_bottom) ||
      (bottom > viewport_top && bottom <= viewport_bottom) ||
      (height > viewport_height && top <= viewport_top && bottom >= viewport_bottom)
  }
  //on screen fix button js end


  // 	if( isOnScreen($(".non-sticky-atc-button").eq(0)) ||
  //      	isOnScreen($(".non-sticky-atc-button").eq(1)) || 
  //      	isOnScreen($(".non-sticky-atc-button").eq(2)) ||
  //      	isOnScreen($(".non-sticky-atc-button").eq(3))
  //       )   {
  //     	$(".sticky-atc-button").fadeOut(100);

  //   	} else {
  //     	$(".sticky-atc-button").fadeIn(100);
  //        if($(window).width() < 767){
  //             $(".sticky-atc-button").fadeIn(10);
  //         } 
  //   	}

  //   	$(window).on('scroll',function(){
  //     	if( isOnScreen($(".non-sticky-atc-button").eq(0)) ||
  // 	     	isOnScreen($(".non-sticky-atc-button").eq(1)) || 
  // 	     	isOnScreen($(".non-sticky-atc-button").eq(2)) ||
  // 	     	isOnScreen($(".non-sticky-atc-button").eq(3)) ) 
  //         {
  //       		$(".sticky-atc-button").fadeOut(10);  

  //     	} else {

  //      		$(".sticky-atc-button").fadeIn(10);
  //            if($(window).width() < 767){
  //             $(".sticky-atc-button").fadeIn(10);
  //         }
  //     	}
  //   	});	


  if (isOnScreen($(".non-sticky-atc-button").eq(0)) ||
      isOnScreen($(".non-sticky-atc-button").eq(1)) ||
      isOnScreen($(".non-sticky-atc-button").eq(2)) ||
      isOnScreen($(".non-sticky-atc-button").eq(3))
     ) {
    $(".sticky-atc-button").fadeOut(10);
  } else {

    if ($(window).width() < 767) {
      $(".non-sticky-atc-button").fadeIn(10);
    }
  }
  $(window).on('scroll', function () {
    if (isOnScreen($(".non-sticky-atc-button").eq(0)) ||
        isOnScreen($(".non-sticky-atc-button").eq(1)) ||
        isOnScreen($(".non-sticky-atc-button").eq(2)) ||
        isOnScreen($(".non-sticky-atc-button").eq(3))
       ) {
      $(".sticky-atc-button").fadeOut(10);
    } else {

      if ($(window).width() < 767) {
        $(".sticky-atc-button").fadeIn(10);
      }
    }
  });


  $('.hamburg-menu').click(function () {
    $('.navMenu').slideToggle();
    $("body").toggleClass('menu-open');
  });
  $('.navMenu a').click(function () {
    $('.navMenu').slideUp();
    $("body").removeClass('menu-open');
  });
  $(document).click(function (e) {
    e.stopPropagation();
    var container = $(".navMenu, .hamburg-menu");

    //check if the clicked area is dropDown or not
    if (container.has(e.target).length === 0) {
      $('.navMenu').slideUp();
      $("body").removeClass('menu-open');
    }
  });

  $('.communitySlider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: false,
    arrows: false,
    dots: false,
    // variableWidth: true,
    prevArrow: '<span class="material-icons prev-arrow">chevron_left</span>',
    nextArrow: '<span class="material-icons next-arrow">chevron_right</span>',
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          dots: true,
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          dots: true,
        }
      },
    ]
      });

      $('.reviewSlider').slick({
      slidesToShow: 3,
      slidesToScroll: 1,
      infinite: false,
      arrows: false,
      dots: false,
      // variableWidth: true,
      prevArrow: '<span class="material-icons prev-arrow">chevron_left</span>',
      nextArrow: '<span class="material-icons next-arrow">chevron_right</span>',
      responsive: [
      {
      breakpoint: 992,
      settings: {
      slidesToShow: 2,
      dots: true,
      }
      },
      {
      breakpoint: 768,
      settings: {
      slidesToShow: 1,
      dots: true,
      }
      },
    ]
  });
  $('.testimonialSlider').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    infinite: false,
    arrows: false,
    dots: false,
    // variableWidth: true,
    prevArrow: '<span class="material-icons prev-arrow">chevron_left</span>',
    nextArrow: '<span class="material-icons next-arrow">chevron_right</span>',
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 2,
          dots: true
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          dots: true
        }
      }
    ]
  });

  // Add minus icon for collapse element which is open by default
  $(".collapse.show").each(function () {
    $(this).prev(".card-header").find(".icon").text("-");
  });

  // Toggle plus minus icon on show hide of collapse element
  $(".collapse").on('show.bs.collapse', function () {
    $(this).prev(".card-header").find(".icon").text("-");
  }).on('hide.bs.collapse', function () {
    $(this).prev(".card-header").find(".icon").text("+");
  });


  // initialize FitVids 
  $(".fitvid").fitVids();




  $(document).on('click', '.qtyplus', function () {
    var line_item = $(this).prev().attr('data-quantity-item');
    if ($(this).prev().val() < 100) {
      $(this).prev().val(+$(this).prev().val() + 1);
    }

  });

  //   // This button will decrement the value
  //$('.qtyminus').click(function () {
  $(document).on('click', '.qtyminus', function () {
    var line_item = $(this).next().attr('data-quantity-item');
    if ($(this).next().val() > 1) {
      if ($(this).next().val() > 1) $(this).next().val(+$(this).next().val() - 1);
    }
  });

  // initialize match Height
  $(".fancybox").fancybox();

  /* scroll to target */
  jQuery('.scrollTo').click(function (e) {
    var jump = jQuery(this).attr('href');
    var new_position = jQuery(jump).offset();
    var scroll = 20;
    jQuery('html, body').stop().animate({ scrollTop: new_position.top + scroll }, 800, function () {
      var new_position = jQuery(jump).offset();
      jQuery('html, body').stop().animate({ scrollTop: new_position.top + scroll }, 800);
    });
    e.preventDefault();
  });


  $('.productBox .innerWrapper .textContent').matchHeight({
    byRow: true,
  });

  // $('.customRadio [type="radio"]').click(function(){
  // 	$('.package .wrapper').removeClass('selected');
  // 	$(this).parents('.wrapper').addClass('selected');
  // });


  if ($('.datepicker div').length > 0) {
    $('.datepicker div').datepicker({
      startDate: "today",
      daysOfWeekDisabled: "0,1",
      autoClose: true,
      todayHighlight: true,
      dateFormat: 'dd/mm/yy'
    }).on('changeDate', function (e) {
      console.log(e.format());
      $.removeCookie("delivery");
      $.cookie("delivery", e.format(), { path: '/' });
    });
  }

  $('.package .wrapper').on('click', function () {
    $('.package .wrapper').removeClass('active');
    $(this).addClass('active');
  });
  
  
});